<template>
  <v-row justify="center">
    <v-btn
      @click="dialogLocalisation = !dialogLocalisation"
      color="purple"
      dark
      rounded
      class="ma-2"
    >
      <v-icon left dark>mdi-map-search</v-icon> Districts</v-btn
    >

    <v-chip
      v-for="(district, index) in district_selected"
      :key="index"
      class="ma-2"
      label
    >
      {{ district.ll_district }}
    </v-chip>

    <v-dialog v-model="dialogLocalisation" max-width="500">
      <v-card>
        <v-card-title>Localisation de {{ user.displayName }}</v-card-title>
        <v-card-text>
          <template>
            <v-form ref="formAddlLocalisationToUser">
              <v-row>
                <v-col>
                  <v-row>
                    <v-select
                      dense
                      @change="setRegions()"
                      :rules="[(v) => !!v || 'Item is required']"
                      :items="provinces"
                      label="Provinces"
                      item-value="id_province"
                      item-text="ll_province"
                      filled
                      v-model="province_selected"
                      required
                      ref="province_selected"
                      multiple
                    ></v-select>
                  </v-row>
                </v-col>
                <v-col>
                  <v-row>
                    <v-select
                      multiple
                      dense
                      @change="setDistricts()"
                      :rules="[(v) => !!v || 'Item is required']"
                      :items="regions"
                      label="Régions"
                      item-value="id"
                      item-text="ll_region"
                      filled
                      v-model="region_selected"
                      required
                      ref="region_selected"
                      :loading="districtLoading"
                    >
                    </v-select
                  ></v-row>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-row>
                    <v-select
                      multiple
                      dense
                      :rules="[(v) => !!v || 'Item is required']"
                      :items="districts"
                      label="Districts"
                      item-text="ll_district"
                      filled
                      v-model="district_selected"
                      required
                      ref="district_selected"
                      return-object
                    >
                    </v-select
                  ></v-row>
                </v-col>
              </v-row>
            </v-form>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded color="warning" dark @click="resetForm()"
            >Annuler</v-btn
          >
          <v-btn
            rounded
            :loading="Loading"
            color="primary"
            dark
            @click="setLocalisationDeUser()"
            >Sauvegarder</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  created() {
    this.provinces = this.$provinces;
    this.regions = [];
  },
  data() {
    return {
      Loading: false,
      dialogLocalisation: false,
      requis: [
        (v) => !!v || "Ce champ est obligatoire",
        (v) => (v && v.length >= 3) || "Au moins trois caractères",
      ],
      emailRules: [
        (v) => !!v || "E-mailrequis",
        (v) => /.+@.+\..+/.test(v) || "E-mail invalide",
      ],
      selectRules: [(v) => !!v || "Veuillez sélectionner une valeur"],
      districtLoading: false,
      communeLoading: false,
      fokontanyLoading: false,
      valid: true,
      provinces: [],
      regions: [],
      districts: this.user.districts,
      communes: [],
      fokontanys: [],
      village: "",
      new_fokontany: "",
      Fokontanydata: "",
      showRegions: true,
      showDistricts: true,
      showCommunes: false,
      showFokontanys: false,
      showNewFokontany: false,
      province_selected: "",
      region_selected: "",
      district_selected: this.user.districts,
      commune_selected: "",
      fokontany_selected: "",
    };
  },
  props: {
    user: {
      required: true,
    },
  },
  computed: {
    ...mapState({}),
  },
  methods: {
    setLocalisationDeUser() {
      var userRef = this.$firebase
        .firestore()
        .collection("users")
        .doc(this.user.uid);

      var setWithMerge = userRef.set(
        {
          districts: this.district_selected,
        },
        { merge: true }
      );
      this.resetForm();
    },

    resetForm() {
      this.$refs.formAddlLocalisationToUser.reset();
      this.dialogLocalisation = false;
    },
    GetUserdetails(idUser) {
      let self = this;
      var userRef = this.$firebase.firestore().collection("users").doc(idUser);
      userRef
        .get()
        .then(function (doc) {
          if (doc.exists) {
            self.userDetails.push({
              ...doc.data(),
              id: doc.id,
            });

            let userUid = self.userDetails[0].uid.toString();
            //let districtsDuSuperviseur = self.userDetails[0].districts;
          } else {
            // doc.data() will be undefined in this case
            console.log("Pas de résultats");
          }
        })
        .catch(function (error) {
          console.log("Error ici getting document:", error);
        });
    },

    setRegions() {
      var self = this;
      const provinceString = this.province_selected.map(String);

      this.showRegions = true;
      this.regions = [];
      this.districts = [];
      this.communes = [];
      this.fokontanys = [];
      this.new_fokontany = "";
      this.showNewFokontany = false;
      this.showDistricts = false;
      this.showCommunes = false;
      this.showFokontanys = false;
      this.$firebase
        .firestore()
        .collection("regions")
        .where("province_id_province", "in", provinceString)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var region = doc.data();
            //console.log(doc.data());
            region.id = doc.id;
            self.regions.push({
              ...region,
            });
            //self.districtLoading = false;
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
    setDistricts() {
      const regionString = this.region_selected.map(String);
      console.log(regionString);
      var self = this;
      this.showDistricts = true;
      this.showCommunes = false;
      this.showFokontanys = false;
      this.showNewFokontany = false;
      this.districtLoading = true;
      this.districts = [];
      this.communes = [];
      this.fokontanys = [];
      this.new_fokontany = "";
      this.$firebase
        .firestore()
        .collection("districts")
        .where("regions_id_region", "in", regionString)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var district = doc.data();
            //console.log(doc.data());
            district.id = doc.id;
            self.districts.push({
              ...district,
              id_district: district.id,
            });
            self.districtLoading = false;
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
      //console.log(this.districts);
    },
    setCommunes() {
      var self = this;
      this.communes = [];
      this.fokontanys = [];
      this.new_fokontany = "";
      this.showCommunes = true;
      this.showFokontanys = false;
      this.showNewFokontany = false;
      this.communeLoading = true;

      this.$firebase
        .firestore()
        .collection("communes")
        .where("id_district", "in", [
          this.district_selected,
          this.district_selected.toString(),
        ])
        .get()
        .then((snap) => {
          snap.forEach((doc) => {
            var commune = doc.data();
            commune.id = doc.id;
            self.communes.push({
              ...commune,
            });
            self.communeLoading = false;
          });
        });
    },
  },
};
</script>

<style scoped></style>
